module.exports = __webpack_public_path__ + "img/boy3.96756ad9.jpg";